import React from "react";
import { FormControl, Select, MenuItem, InputLabel } from "@mui/material";
import { MAX_DROPDOWN_HEIGHT } from "../../types/micellinous-constants";

function HealthcareWorkerFilter({
  selectedHealthcareWorker,
  setSelectedHealthcareWorker,
}) {
  const handleHealthcareWorkerChange = (event) => {
    setSelectedHealthcareWorker(event.target.value);
  };

  return (
    <FormControl style={{ width: "70%" }}>
      <InputLabel id="healthcare-worker-select-label">
        Healthcare Worker
      </InputLabel>
      <Select
        labelId="healthcare-worker-select-label"
        id="healthcare-worker-select"
        value={selectedHealthcareWorker}
        onChange={handleHealthcareWorkerChange}
        MenuProps={{
          style: {
            maxHeight: MAX_DROPDOWN_HEIGHT,
          },
        }}
      >
        <MenuItem value="All">All</MenuItem>
        <MenuItem value="Nurse">Nurse</MenuItem>
        <MenuItem value="Physician">Physician</MenuItem>

        <MenuItem value="Registered Staff">Registered Staff</MenuItem>
        <MenuItem value="PSW">PSW</MenuItem>
        <MenuItem value="Student">Student</MenuItem>
        <MenuItem value="Dietary">Dietary</MenuItem>
        <MenuItem value="Social worker">Social worker</MenuItem>
        <MenuItem value="Pastoral care">Pastoral care</MenuItem>
        <MenuItem value="Lab/X-ray/blood collection">
          Lab/X-ray/blood collection
        </MenuItem>
        <MenuItem value="OT/PT/PTA (Therapy Staff)">
          OT/PT/PTA (Therapy Staff)
        </MenuItem>
        <MenuItem value="Housekeeping">Housekeeping</MenuItem>
        <MenuItem value="Laundry staff">Laundry staff</MenuItem>
        <MenuItem value="Volunteer">Volunteer</MenuItem>
        <MenuItem value="Programs">Programs</MenuItem>
        <MenuItem value="Essential Caregiver">Essential Caregiver</MenuItem>
        <MenuItem value="Private caregiver">Private caregiver</MenuItem>
        <MenuItem value="One-to-one worker">One-to-one worker</MenuItem>
        <MenuItem value="Dental services">Dental services</MenuItem>
        <MenuItem value="BSO">BSO</MenuItem>
        <MenuItem value="Optometry">Optometry</MenuItem>
        <MenuItem value="Hair Stylist">Hair Stylist</MenuItem>
        <MenuItem value="Nurse Practitioner">Nurse Practitioner</MenuItem>
        <MenuItem value="General visitor">General visitor</MenuItem>
        <MenuItem value="Footcare nurse">Footcare nurse</MenuItem>
        <MenuItem value="Admin">Admin</MenuItem>
        <MenuItem value="Security">Security</MenuItem>
        <MenuItem value="Maintenance">Maintenance</MenuItem>
      </Select>
    </FormControl>
  );
}

export default HealthcareWorkerFilter;
